import { call } from 'redux-saga/effects';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { userNameDecrypted } from 'features/e2ee/actions';

export function* onUserNameDecryptedSaga(action: ReturnType<typeof userNameDecrypted>) {
  yield call(E2EEManager.releasePendingActions, action.payload.id, action.payload.roomId);
}
